import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';

export default class ScrollToTopOnMount extends Component{
    componentDidMount(){
        window.scrollTo(0,0)
    }

    render(){
        return this.props.children
    }
}
